import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { ModalService } from "src/app/service/modal-service";
import { AuthService } from "src/app/service/auth.service";
import { SystemService } from "src/app/service/system.service";
import { NotificationService } from "src/app/service/notification-service";
import { Router } from "@angular/router";
import { AdminAuthGuard } from "../../service/admin-auth.guard";
import { UserAuthGuard } from "../../service/user-auth.guard";
import { TimeoutService } from "src/app/service/timeout.service";
import { UserSessionVo } from "src/app/data/user-session-vo";
import { UserSessionPingService } from "src/app/service/user-session-ping.service";

@Component({
  selector: "app-logout",
  templateUrl: "./logout.component.html",
  styleUrls: ["./logout.component.css"],
})
export class LogoutComponent implements OnInit {
  @Output() logoutEvent = new EventEmitter();
  constructor(
    private modalService: ModalService,
    private authService: AuthService,
    private notifyService: NotificationService,
    private systemService: SystemService,
    private router: Router,
    private adminAuthGuard: AdminAuthGuard,
    private userAuthGuard: UserAuthGuard,
    private timeoutService: TimeoutService,
    private userSessionPingService: UserSessionPingService
  ) {}

  ngOnInit() {}

  openModal(id: string) {
    this.modalService.open(id);
  }

  closeModal(id: string) {
    this.modalService.close(id);
  }

  doLogout() {
    const userId = this.systemService.userSessionVo["userId"];
    this.authService.logout(userId).subscribe((data) => {
      this.notifyService.inspectResult(data);
      if (
        JSON.stringify(data["courseOfActionVo"]["storedObject"]) === '"SUCCESS"'
      ) {
        this.userSessionPingService.disable(true);
        this.logoutEvent.emit();
        this.closeModal("logout-modal");
        this.systemService.userSessionVo = <UserSessionVo>{};
        this.systemService.messageBoardCounter = 0;
        this.adminAuthGuard.reset();
        this.userAuthGuard.reset();
        // clearInterval(this.timeoutService.refreshIntervalId);
        this.timeoutService.disable(true);
        this.timeoutService.reset();
        this.systemService.userLoggedOut = true;
        this.router.navigate([""]);
      }
    });
  }
}
